import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_QUANTITY_SELECTOR } from '@estee/elc-service-view-names';
import { IProductQuantitySelector } from './ProductQuantitySelector';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductQuantitySelector>(
    () => import('./ProductQuantitySelector'),
    PRODUCT_QUANTITY_SELECTOR
);
